import {
  FREEZE_REQUEST,
  FREEZE_SUCCESS,
  FREEZE_FAILURE,
  UNFREEZE_REQUEST,
  UNFREEZE_SUCCESS,
  UNFREEZE_FAILURE
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case FREEZE_REQUEST:
    case UNFREEZE_REQUEST:
      return {
        ...state,
        freezeActionPending: true
      };
    case FREEZE_SUCCESS:
    case UNFREEZE_SUCCESS:
    case FREEZE_FAILURE:
    case UNFREEZE_FAILURE:
      return {
        ...state,
        freezeActionPending: false
      };
    default:
      return state;
  }
};
